import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {KnockoutFieldModel} from "../../knockout-field/knockout-field.model";
import {FieldService} from "../../../services/field/field.service";
import {$translate} from "../../../services/internationalization/localize.service";
import {DialogComponent} from "@syncfusion/ej2-angular-popups";

@Component({
  selector: 'sb-kanban-add-member-dialog',
  templateUrl: './kanban-add-member-dialog.component.html',
  styleUrls: ['./kanban-add-member-dialog.component.scss']
})
export class KanbanAddMemberDialogComponent implements OnInit {
  @ViewChild(DialogComponent) dialogComponent: DialogComponent

  @Input('showModal')
  showModal: boolean = false;

  @Output('userSelected')
  userSelectedEmitter : EventEmitter<string> = new EventEmitter()

  @Input('userIdsToExclude')
  get userIdsToExclude(): string[] { return this._userIdsToExclude }
  set userIdsToExclude(ids: string[]) {
    this._userIdsToExclude = ids;
    this.initNewMemberField();
  };

  _userIdsToExclude: string[] = [];

  memberReferenceField: KnockoutFieldModel = null;

  private selectUserToAddLabel: string;
  addMemberButtonLabel: string;
  cancelButtonLabel: string;

  userSelected: string;
  isAddButtonDisabled: boolean = true;
  headerLabel: string;

  constructor(private fieldService: FieldService) { }

  ngOnInit(): void {
    this.selectUserToAddLabel = $translate("ng.component.kanban.add.member.dialog.input-label")`Select user`;
    this.addMemberButtonLabel = $translate("ng.component.kanban.add.member.dialog.add-button-label")`Add member`;
    this.cancelButtonLabel = $translate("ng.component.kanban.add.member.dialog.cancel-button-label")`Cancel`;
    this.headerLabel = $translate("ng.component.kanban.add.member.dialog.header-label")`Add Member`;
  }

  show() {
    if (!this.memberReferenceField) {
      this.initNewMemberField();
    }
    this.showModal = true;
  }

  onUserChange(assigneeId: string | null) {
    this.userSelected = assigneeId;
    this.isAddButtonDisabled = assigneeId == null
  }

  onAddMemberClick() {
    this.userSelectedEmitter.emit(this.userSelected);
    this.close();
  }

  close() {
    this.clearUserInput();
    this.showModal = false;
  }

  private initNewMemberField() {
    this.memberReferenceField = this.fieldService.createReferenceField(
      'User',
      this.selectUserToAddLabel,
      'User',
      {
        valueChangeCallback: value => this.onUserChange(value),
        rendererProperties: {
          additionalFilterQuery: (this.userIdsToExclude || {}).length > 0 ? {"fieldName": "id","operator": "notIn","value": this.userIdsToExclude} : {}
        }
      });
  }

  private clearUserInput() {
    this.memberReferenceField.data.answer = {
      value: null,
      displayValue: null
    }
  }
}
